import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Form } from "react-bootstrap";
import { OutputSettingsBaseCardProps } from "./OutputSettingsBaseCard";
import { FieldValidation } from "../useCreateWizard";
import { BaseValidatedFormGroup, ValidatedFormControl } from "../validation";

export const NamingCard: React.FC<
    OutputSettingsBaseCardProps & {
        validation?: FieldValidation;
    }
> = ({ outputSettings, onOutputSettingsChange, validation }) => {
    const { t } = useTranslation("wizard");

    const handleSettingChange = (key: keyof typeof outputSettings, value: any) => {
        onOutputSettingsChange({
            [key]: value,
        });
    };

    return (
        <Card className="mb-3">
            <Card.Header>
                <h5 className="mb-0">{t("cards.naming.title")}</h5>
            </Card.Header>
            <Card.Body>
                <BaseValidatedFormGroup className="mb-3" validation={validation}>
                    <Form.Label>{t("cards.naming.documentName")}</Form.Label>
                    <ValidatedFormControl
                        type="text"
                        value={outputSettings.documentName ?? ""}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleSettingChange("documentName", e.target.value)
                        }
                        validation={validation}
                    />
                    <Form.Text className="text-muted">{t("cards.naming.description")}</Form.Text>
                </BaseValidatedFormGroup>
            </Card.Body>
        </Card>
    );
};
